import styled from 'styled-components'

const Wrapper = styled.div`
  position: relative;
  margin: 0 auto;
  max-width: 1050px;
  padding: 165px 53px;
`
const Message = styled.div`
  margin-top: 40px;
  text-align: center;
  font-size: 36px;
  font-weight: 300;
  color: #313131;
`

export const Styled = {
  Wrapper,
  Message
}
